import React from 'react';

//Estilos base:
let mainCardStyle = {
    paddingTop: 20
};

export const downloadSourcesConfigurationTourConfig = [
    {
        selector: '',
        content: () => (
            <div style={{ ...mainCardStyle }}>
                <p>Esta es la consola de <b>configuración de descargas</b>.</p>
                <p>Esta es una zona de <b>alto riesgo</b>, pues todos los procesos de descarga dependen de
                la <b>parametrización</b> en JSON aquí manipulable.</p>
            </div>
        )
    },
    {
        style: { ...mainCardStyle },
        selector: '[data-tut="reactour__sourcesConfiguration.sourceSelector"]',
        content: () => (
            <div style={{ ...mainCardStyle }}>
                <p>Con esta herramienta, puedes seleccionar la <b>fuente para editar</b>.</p>
                <p>Cada vez que cambies la selección, la parametrización se actualizará en el módulo de la derecha.</p>
            </div>
        )
    },
    {
        style: { ...mainCardStyle },
        selector: '[data-tut="reactour__sourcesConfiguration.JSONUpdaterContainer"]',
        content: () => (
            <div style={{ ...mainCardStyle }}>
                <p>Este módulo permite visualizar la <b>parametrización actual</b> y manipularla.</p>
                <p>La parametrización está en <b>formato JSON</b> y se edita como tal.</p>
                <p>Cualquier cambio requiere permisos especiales y se traducirá en un registro de <b>auditoría</b>.</p>
            </div>
        )
    },
    {
        style: { ...mainCardStyle },
        selector: '[data-tut="reactour__sourcesConfiguration.JSONUpdater"]',
        content: () => (
            <div style={{ ...mainCardStyle }}>
                <p>Para <b>modificar</b> una variable, acerca el cursor al dato en cuestión y haz click en el icono del lápiz.</p>
                <p>Los cambios <b>no se guardarán</b> hasta que hagas click en el icono del <b>disquette</b>.
                 Este no aparecerá si no hay cambios hechos.</p>
            </div>
        )
    },
    {
        style: { ...mainCardStyle },
        selector: '[data-tut="reactour__sourcesConfiguration.JSONUpdaterLightModeButton"]',
        content: () => (
            <div style={{ ...mainCardStyle }}>
                <p>Con este botón puedes <b>alternar</b> entre modo de visualización oscuro o claro.</p>
                <p>Es algo que nos gusta a los desarrolladores
                    <span role="img" aria-label="sourcesConfigTourEmoji" style={{ marginLeft: 5 }}>🧐</span>.</p>
            </div>
        )
    },
    {
        style: { ...mainCardStyle },
        selector: '[data-tut="reactour__sourcesConfiguration.JSONReverseDefaultButton"]',
        content: () => (
            <div style={{ ...mainCardStyle }}>
                <p>Con este botón puedes <b>restaurar</b> la configuracion a su valor por defecto.</p>
                <p>En caso de que sientas que modificaste algo que no debias
                    <span role="img" aria-label="sourcesConfigTourEmoji" style={{ marginLeft: 5 }}>🧐</span>.</p>
            </div>
        )
    },
    {
        style: { ...mainCardStyle },
        selector: '[data-tut="reactour__sourcesConfiguration.JSONUpdater"]',
        content: () => (
            <div style={{ ...mainCardStyle }}>
                <p>Recuerda: esta es una zona de <b>alto riesgo</b>, pues corresponde a las 
                instrucciones que sigue el robot que ejecuta las descargas.</p>
            </div>
        )
    },
    {
        style: { ...mainCardStyle },
        selector: '[data-tut="reactour__sourcesConfiguration.equivalencesUpdater"]',
        content: () => (
            <div style={{ ...mainCardStyle }}>
                <p>Algunas fuentes requieren archivos con <b>data previa</b>.</p>
                <p>A través de este módulo, podrás <b>descargar</b> el estado actual de dicha data previa, <b>actualizarla</b> y <b>resetearla</b>.</p>
            </div>
        )
    },

];